angular
    .module('festzelt-os.modules.tickets')
    .config([
        '$stateProvider',
        config
    ]);

function config($stateProvider) {
    $stateProvider
        .state('app.tickets', {
            abstract: true,
            url: '/tickets/',
            template: '<ui-view/>',
            data: {
                pageTitle: 'Tickets',
                showBackBtn: true
            }
        });
}



// WEBPACK FOOTER //
// ./src/app/modules/tickets/routes.js